import Ajv2020 from 'ajv/dist/2020.js'
import stageStateSchema from '../schema/stage-state.v1.schema.json'
import type { StageStateV1 } from './index'

const ajv = new Ajv2020({ allErrors: true, strict: false })
const validateStageState = ajv.compile(stageStateSchema)

export type StageValidationResult =
  | { valid: true; value: StageStateV1; errors: [] }
  | { valid: false; value: null; errors: string[] }

export function validateStageStateV1(input: unknown): StageValidationResult {
  if (validateStageState(input)) {
    return { valid: true, value: input as StageStateV1, errors: [] }
  }

  const errors = (validateStageState.errors ?? []).map((error) => {
    const location = error.instancePath || '/'
    return `${location}: ${error.message ?? error.keyword}`
  })

  return { valid: false, value: null, errors }
}
